import { gql } from 'apollo-angular'

export const GET_DOMAINS_BY_ORG = gql`
  query GetDomainNames($organizationId: JSON!) {
    OrganizationDomains(where: { organization: { equals: $organizationId } }) {
      docs {
        id
        domain
      }
    }
  }
`
